import React from 'react';

import { getMarketingCoupon, getMarketingPlan } from '@/helpers/pricing';
import { useLocation } from 'react-router';

import { PublicLayoutHeader } from '../PublicLayoutHeader';
import styles from './PlanSignupBanner.module.scss';

export const PlanSignupBanner: React.FC = () => {
	const { search } = useLocation();
	const plan = getMarketingPlan(search);
	const coupon = getMarketingCoupon(search);
	console.log('[PlanSignupBanner]', { search, plan });

	if (plan === 'leader') {
		return (
			<PublicLayoutHeader>
				You're subscribing to the <span className={styles.bold}>Leader</span> plan{' '}
				{coupon ? (
					<>
						with <br />
						<span className={styles.bold}>{coupon}</span> applied.
					</>
				) : (
					<>
						for <br />
						<span className={styles.bold}>$12 USD/mo</span>.
					</>
				)}{' '}
				Log in or sign up to continue.
			</PublicLayoutHeader>
		);
	}

	if (plan === 'team') {
		return (
			<PublicLayoutHeader>
				You're subscribing to the <span className={styles.bold}>Team</span> plan from <br />
				<span className={styles.bold}>$39 USD/mo</span>. Log in or sign up to continue.
			</PublicLayoutHeader>
		);
	}

	return null;
};
